import { deleteData, getData, postData, patchData } from "../../common/utils/network.utils";

// Beneficiary/Node operations
export const getHoldingEntityData = async () => {
  return (await getData('beneficiary-graph')).data;
};

export const getBeneficiaries = async () => {
  return (await getData('beneficiary-graph/beneficiaries')).data;
};

export const createHoldingEntity = async (data) => {
  return (await postData('beneficiary-graph/beneficiary', data));
};

export const updateHoldingEntity = async (data) => {
  return (await patchData(`beneficiary-graph/beneficiary/${data.id}`, data));
};

export const deleteHoldingEntity = async (id) => {
  return (await deleteData(`beneficiary-graph/beneficiary/${id}`));
};

// Connection/Edge operations
export const getConnections = async () => {
  return (await getData('beneficiary-graph/connections')).data;
};

export const createConnection = async (data) => {
  return (await postData('beneficiary-graph/connections', data));
};

export const updateConnection = async (connectionId, data) => {
  return (await patchData(`beneficiary-graph/connections/${connectionId}`, data));
};

export const deleteConnection = async (connectionId) => {
  return (await deleteData(`beneficiary-graph/connections/${connectionId}`));
};

export const reassignConnection = async (connectionId, newChildBeneficiaryId) => {
  return (await postData(`beneficiary-graph/connections/${connectionId}/reassign/${newChildBeneficiaryId}`, {}));
};

export const bulkEditPositions = async (data) => {
  return (await patchData('beneficiary-graph/bulk-update-positions', data));
};

export const reArrangeGraph = async () => {
  return (await patchData('beneficiary-graph/rearrange-beneficiaries'));
};